<template>
    <div v-if="album" class="mobile-menu">
        <div v-if="mobileMainMenu" class="mobile-menu__container js-mobile-menu-container">
            <div class="mobile-menu__container-inner">
                <div class="mobile-menu__hidden-album-box mobile-hidden-album-box">
                    <div class="mobile-hidden-album-box__title">{{ $t('private_gallery') }}</div>
                    <div class="mobile-hidden-album-box__text">
                        {{ $t('descriptions.personal_albums') }}
                    </div>
                    <hidden-album-form/>
                </div>
                <div class="mobile-menu__content">
                    <ul class="mobile-menu__links">
                        <li v-for="(page, i) in pages" :key="i" class="mobile-menu__link">
                            <a href="#" @click.prevent="goTo(page.path)" :class="{active: isActiveRoute(page.path)}">
                                <span v-if="page.lockIcon" class="material-icon" :class="!!customerAlbums.length ? 'icon-lock_open' : 'icon-lock_outline'"/>
                                <span class="text-with-icon">{{ page.name }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <ul class="mobile-menu__actions">
            <li v-if="mobileMainMenu || +album.free_download" class="mobile-menu__action">
                <mobile-account-menu v-if="mobileMainMenu" @handle-account-menu="showCloseBtn = !$event" @handle-fullscreen="fullscreen = $event"/>
                <form  v-else-if="+album.free_download" :action="`${apiUrl}v2/albums/${downloadUrl}`" method="post" target="_blank">
                    <input v-if="privateTags" type="hidden" name="X-bk-tags" :value="privateTags">
                    <button type="submit" class="action-link">
                        <span class="material-icon icon-cloud_download"/>
                        <span class="action-link__txt">{{ $t('download_album') }}</span>
                    </button>
                </form>
            </li>
            <li class="mobile-menu__action mobile-menu__action--favorite" :class="{'mobile-menu__action--disabled': !favoritesLength || favoritesLength === 0 || !products || products && !products.length}">
                <mobile-favorites-menu/>
            </li>
            <li class="mobile-menu__action" :class="{'mobile-menu__action--disabled': !cart || cart && !cart.quantity}">
                <a href="#" class="action-link" @click.prevent="goTo(i18nLink('cart'))">
                    <span class="material-icon icon-add_shopping_cart"/>
                    <span class="action-link__txt">{{ $t('cart') }}</span>
                    <span v-if="cart && !!cart.quantity" class="badge badge-success">{{ cart.quantity }}</span>
                </a>
            </li>
        </ul>
        <a v-if="showCloseBtn && !mobileFavoritesMenu" href="#" @click.prevent="$store.dispatch('SET_MOBILE_MAIN_MENU', !mobileMainMenu)" class="mobile-menu__btn" :class="{'-red': mobileMainMenu}">
            <span class="material-icon" :class="mobileMainMenu ? 'icon-clear' : 'icon-menu'"/>
        </a>
    </div>
</template>

<script>
  import MobileFavoritesMenu from './MobileFavoritesMenu';
  import MobileAccountMenu from './MobileAccountMenu.vue';

  import MobileAlbumMenu from 'src/mixins/mobileAlbumMenuComponent';

  export default {
    mixins: [MobileAlbumMenu],
    components: {
      MobileFavoritesMenu,
      MobileAccountMenu
    },
  };
</script>
